module.exports = __webpack_public_path__ + "static/media/IMC.e5f1cb0e.svg";